import React from 'react'

export function useStickyHeaderStyle(): React.CSSProperties | undefined {
  // TODO: set this to be a setting in the more file options menu
  const shouldUseStickyHeaders = true
  const stickyStyle = React.useMemo(() => {
    return shouldUseStickyHeaders
      ? {
          top: '0px',
          zIndex: 4,
          background: 'var(--bgColor-default, var(--color-canvas-default))',
          position: 'sticky' as const,
        }
      : undefined
  }, [shouldUseStickyHeaders])

  return stickyStyle
}
